import template from './app.html';
import './app.scss';

const appComponent = {
  template,
};

export default appComponent;



// WEBPACK FOOTER //
// ./client/app/app.component.js